module.exports = __webpack_public_path__ + "img/icon-saveqr@2x.157a4485.png";